import React from 'react';
import '../Styles/App.css'

const SiteFoot = (props) => {


    return (
       <div>

           { props.lang==="en" &&  <div  style={{backgroundColor:"white", color:"Gray", fontSize: ".5em", width: "100%", display: "flex", bottom: "0px", position:"fixed", left: "0px"}}>
            ©2019-2022 The Morrow Firm. All Rights Reserved. Attorney Advertising. Prior results do not guarantee a similar outcome.
        </div>}

           { props.lang==="zh" &&  <div  style={{backgroundColor:"white", color:"Gray", fontSize: ".7em", width: "100%", display: "flex", bottom: "0px", position:"fixed", left: "0px"}}>
               ©2019-2022 美国沫若律师事务所版权所有。律师广告。此前结果不保证类似结果。
           </div>}
       </div>

    )
};

export default SiteFoot;



// WEBPACK FOOTER //
// ./src/Components/SiteFoot.js